import { useState, useCallback, useRef } from 'react';

interface UseTurnstileReturn {
  siteKey: string | undefined;
  token: string | null;
  isReady: boolean;
  hasError: boolean;
  onSuccess: (token: string) => void;
  onError: () => void;
  onExpire: () => void;
  reset: () => void;
  widgetRef: React.RefObject<any>;
}

export const useTurnstile = (siteKey?: string): UseTurnstileReturn => {
  const [token, setToken] = useState<string | null>(null);
  const [isReady, setIsReady] = useState(false);
  const [hasError, setHasError] = useState(false);
  const widgetRef = useRef<any>(null);

  const onSuccess = useCallback((newToken: string) => {
    setToken(newToken);
    setIsReady(true);
    setHasError(false);
  }, []);

  const onError = useCallback(() => {
    setToken(null);
    setIsReady(false);
    setHasError(true);
  }, []);

  const onExpire = useCallback(() => {
    setToken(null);
    setIsReady(false);
    setHasError(false);
  }, []);

  const reset = useCallback(() => {
    setToken(null);
    setIsReady(false);
    setHasError(false);
    widgetRef.current?.reset();
  }, []);

  return {
    siteKey,
    token,
    isReady,
    hasError,
    onSuccess,
    onError,
    onExpire,
    reset,
    widgetRef,
  };
};
